function waitForSlick(callback) {
  if (window.jQuery && typeof $.fn.slick !== "undefined") {
    callback();
  } else {
    setTimeout(function () {
      waitForSlick(callback);
    }, 50);
  }
}

waitForSlick(function () {
  console.log("jQuery version:", jQuery.fn.jquery);
  console.log("Slick exists?", typeof $.fn.slick !== "undefined");
  console.log("Initializing Slick on", $(".slick-slider"));

  // Hide the slider container initially to prevent unstyled content
  $(".slick-slider").css("visibility", "hidden");

  $(".slick-slider")
    .on("init", function (event, slick) {
      // Once Slick initializes, make the slider visible
      $(this).css("visibility", "visible");

      // Handle the first slide's video playback
      var $firstVideo = $(slick.$slides[0]).find("video");
      if ($firstVideo.length) {
        // Slight delay to ensure the video element is fully ready
        setTimeout(function () {
          $firstVideo.get(0).play();
        }, 100);
      }
    })
    .slick({
      autoplay: true,
      autoplaySpeed: 10000,
      arrows: true,
      dots: true,
      fade: false,
      cssEase: "cubic-bezier(.5,0,.5,.95)",
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-prev"><svg class="d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path fill="white" d="M59.74 115.2a2.59 2.59 0 0 1-3.66 0L.76 59.8a2.58 2.58 0 0 1 0-3.65L56.08.76a2.58 2.58 0 0 1 3.66 3.65L6.24 58l53.5 53.56a2.59 2.59 0 0 1 0 3.66z"></path></svg></button>',
      nextArrow: '<button class="slick-next"><svg class="d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.5 115.95"><path fill="white" d="M.76.76a2.58 2.58 0 0 1 3.65 0l55.33 55.4a2.58 2.58 0 0 1 0 3.65L4.4 115.2a2.58 2.58 0 1 1-3.65-3.65L54.26 58 .76 4.42a2.59 2.59 0 0 1 0-3.66z"></path></svg></button>',
    })
    .on("afterChange", function (event, slick, currentSlide) {
      // Pause and reset all videos on slide change
      $(".slick-slider .slick-item video").each(function () {
        this.pause();
        this.currentTime = 0;
        $(this).css("opacity", 0); // Ensure all videos start hidden
      });

      // Play the active slide's video if available
      var activeVideo = $(".slick-slider .slick-active video");
      if (activeVideo.length) {
        setTimeout(function () {
          activeVideo[0].play();
          activeVideo.fadeTo(200, 1); // Fade in over 0.2s
        }, 100); // Small delay to prevent flickering
      }
    });
});
